import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog";
import { Button } from "../../ui/button";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "../../ui/input-opt";
import phone from "@/shared/api/phone";

export function VerifyPhoneDialog({
  open,
  onOpenChange,
  phoneNumber,
  onVerify,
}) {
  const [code, setCode] = useState("");
  const [timer, setTimer] = useState(60);
  const [startTimer, setStartTimer] = useState(true);

  useEffect(() => {
    if (!startTimer) return;
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setStartTimer(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [startTimer]);

  const handleVerify = () => {
    if (code.length === 6) {
      onVerify(code);
      setCode("");
    }
  };

  const handleResend = async () => {
    await phone.resendPhone(phoneNumber);
    setTimer(60);
    setStartTimer(true);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md bg-olive-50 border">
        <DialogHeader>
          <DialogTitle className="text-olive-900">
            Верификация номера
          </DialogTitle>
          <DialogDescription className="text-olive-800">
            Введите 6-значный код, отправленный на номер{" "}
            <span className="text-[#556B2F]">{phoneNumber}</span>
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col items-center gap-6 py-4">
          <InputOTP
            maxLength={6}
            value={code}
            onChange={(value) => setCode(value)}
          >
            <InputOTPGroup>
              <InputOTPSlot
                index={0}
                className="border-[#808000]/30 data-[active=true]:border-[#6B8E23] data-[active=true]:ring-[#6B8E23] text-olive-900 h-12 w-12"
              />
              <InputOTPSlot
                index={1}
                className="border-[#808000]/30 data-[active=true]:border-[#6B8E23] data-[active=true]:ring-[#6B8E23] text-olive-900 h-12 w-12"
              />
              <InputOTPSlot
                index={2}
                className="border-[#808000]/30 data-[active=true]:border-[#6B8E23] data-[active=true]:ring-[#6B8E23] text-olive-900 h-12 w-12"
              />
              <InputOTPSlot
                index={3}
                className="border-[#808000]/30 data-[active=true]:border-[#6B8E23] data-[active=true]:ring-[#6B8E23] text-olive-900 h-12 w-12"
              />
              <InputOTPSlot
                index={4}
                className="border-[#808000]/30 data-[active=true]:border-[#6B8E23] data-[active=true]:ring-[#6B8E23] text-olive-900 h-12 w-12"
              />
              <InputOTPSlot
                index={5}
                className="border-[#808000]/30 data-[active=true]:border-[#6B8E23] data-[active=true]:ring-[#6B8E23] text-olive-900 h-12 w-12"
              />
            </InputOTPGroup>
          </InputOTP>
          {timer > 0 ? (
            <div className="text-muted-foreground">
              Подождите {timer} секунд для повторной отправки кода.
            </div>
          ) : (
            <Button
              variant="link"
              onClick={handleResend}
              className="text-olive-900 hover:text-[#556B2F]"
            >
              Отправить код повторно
            </Button>
          )}
        </div>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            Отмена
          </Button>
          <Button
            type="button"
            onClick={handleVerify}
            disabled={code.length !== 6}
          >
            Подтвердить
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
